
export type OrderDetailResponseOrder = {
  amount?: number;
  createdAt?: string;
  orderId?: string;
  productName?: string;
  status?: string;
  userId?: string;
};
